import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CreditCard, Loader2 } from 'lucide-react';
import { SoldeDuLigne } from './SoldeDu';
import { getToken } from '../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `${(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const SoldeDuPayable = ({ solde, getAuthHeader = authHeader }) => {
  const [busy, setBusy] = useState(null);
  const payer = async (choix) => {
    setBusy(choix);
    try {
      const { data } = await axios.post(`${API}/solde-du/payer/${solde.souscription_id}`, { choix }, { headers: getAuthHeader() });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Paiement impossible pour le moment');
      setBusy(null);
    }
  };
  const ech = solde.prochaine_echeance;
  const btn = 'inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold disabled:opacity-50';
  return (
    <div className="space-y-2">
      <SoldeDuLigne solde={solde} />
      <div className="flex flex-wrap gap-2">
        {ech?.montant > 0 && (
          <button onClick={() => payer('echeance')} disabled={!!busy} className={`${btn} border border-emerald-600 text-emerald-700 hover:bg-emerald-50`} data-testid={`payer-echeance-${solde.souscription_id}`}>
            {busy === 'echeance' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CreditCard className="h-3.5 w-3.5" />}
            Payer la prochaine échéance ({eur(Math.min(ech.montant, solde.reste))})
          </button>
        )}
        <button onClick={() => payer('tout')} disabled={!!busy} className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid={`payer-tout-${solde.souscription_id}`}>
          {busy === 'tout' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CreditCard className="h-3.5 w-3.5" />}
          Payer tout le reste ({eur(solde.reste)})
        </button>
      </div>
    </div>
  );
};

export const useConfirmationSolde = (getAuthHeader, onDone) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('solde_session');
    if (!sid) return;
    params.delete('solde_session');
    window.history.replaceState({}, '', `${window.location.pathname}${params.toString() ? `?${params}` : ''}`);
    axios.post(`${API}/solde-du/confirmer`, { session_id: sid }, { headers: getAuthHeader() })
      .then(({ data }) => {
        if (data.paye) toast.success(`Paiement de ${eur(data.montant)} enregistré, merci ! Votre reçu est mis à jour.`);
        else toast.info('Paiement non finalisé.');
        onDone?.();
      })
      .catch(() => toast.error('Vérification du paiement impossible'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
